import React, { createContext, useState } from 'react';

import RecordsData from './RecordsData';

export const RecordsStateContext = createContext();

const RecordsContextProvider = ({ children }) => {
  const stateHook = useState(RecordsData.INITIAL_STATE);

  return (
    <RecordsStateContext.Provider value={stateHook}>
      {children}
    </RecordsStateContext.Provider>
  );
};

export default RecordsContextProvider;